@if (showCameraPopUp) {
  <kx-camera-audio-permssion [device]="device" [resource]="resourceName" (closedevicePopup)="closedevicePopup($event)"></kx-camera-audio-permssion>
}
<div class="header" ngxModalDraggable
  [ngClass]="teleService.currentCall.minimized && isMobile()?'minimized_screen_header':'full_screen_header'"
  [ngStyle]="teleService.currentCall.minimized?{'background': '#00598D'}:{'background':'none'}">
  @if (teleService.currentCall.minimized && isMobile()) {
    <div class="ongoing-status-container"
      (click)="teleService.changeToPopup()">
      <div class="ongoing-status">
        <i class="fa fa-circle"></i>
        On going Video Call
        <i class="fa fa-circle"></i>
      </div>
    </div>
  }
  @if (!(teleService.currentCall.minimized && isMobile())) {
    <div class="tele-modal-heading float-left">
      <i class="fa fa-window-close tele-close cursor-pointer text-light" aria-hidden="true"
      (click)="leavechannel(key,true)"></i>
      <h5 class="modal-title d-inline-block cursor-pointer text-light">
        <small class="additional_text"></small> {{teleService.currentCall.name}}
      </h5>
    </div>
  }
  @if (!(teleService.currentCall.minimized && isMobile())) {
    <div class="tele-modal-header-actions float-right">
      <span class="buttons cursor-pointer">
        @if (!teleService.currentCall.minimized) {
          <img src="assets/images/telemedicine/iconMinimise.png" class="px-1"
            (click)="teleService.changeToMinimized();">
        }
        @if (teleService.currentCall.minimized) {
          <img src="assets/images/telemedicine/iconMinimise1.png" class="px-1">
        }
        @if (teleService.currentCall.fullScreen || teleService.currentCall.minimized) {
          <img src="assets/images/telemedicine/iconMedium.png"
            class="max px-1"
            (click)="teleService.changeToMiniPlayer()">
        }
        @if (!teleService.currentCall.fullScreen && !teleService.currentCall.minimized) {
          <img src="assets/images/telemedicine/iconMedium1.png"
            class="max px-1">
        }
        @if (!teleService.currentCall.fullScreen) {
          <img src="assets/images/telemedicine/iconLarge.png" class="max px-1"
            (click)="teleService.changeToPopup()">
        }
        @if (teleService.currentCall.fullScreen) {
          <img src="assets/images/telemedicine/iconLarge1.png" class="max px-1">
        }
      </span>
    </div>
  }
</div>
<div style="position: relative;" [hidden]="teleService.currentCall.minimized">
  @if (!showVideo) {
    <div class="video-grid telem-video-container" id="video" ngxModalDraggable
      [ngStyle]="teleService.currentCall.fullScreen?{'height': '80vh'} : {'height': '40vh'}"
      style="margin: auto;width: 100%; background: black;">
      <!-- <div class="col-12 py-5 text-center" *ngIf="teleService.currentCall.emrKey && localMedia" id="connectingText">
      <kx-patient-view-queue [id]="teleService.currentCall.emrKey.id" [resource]="'patient_pending_order'">
      </kx-patient-view-queue>
    </div> -->
    <!-- Add the audio waveform HTML here -->
    <!-- Audio waveform for audio-only calls -->
    @if (showAudioWaveform && enterRoom) {
      <div class="audio-waveform-container">
        <div class="audio-waveform">
          @for (i of [1,2,3,4,5,6,7]; track i) {
            <div class="waveform-bar"></div>
          }
        </div>
        <div class="participant-info">
          <div class="participant-avatar">{{this.auth.getCurrentUser().first_name[0]}}</div>
          <div class="participant-name">{{this.auth.getCurrentUser().first_name}}</div>
        </div>
        <div class="call-status">Audio Call</div>
      </div>
    }
    @if (localMedia) {
      <div class="col-12 text-center text-light text-show text-capitalize"
        [ngClass]="teleService.currentCall.fullScreen?'full_screen': 'mini_screen'">
        {{'field.label.welcome' | translate | async}} {{this.auth.getCurrentUser().first_name}}
      </div>
    }
    @if (localMedia) {
      <div class="col-12 text-center" [ngClass]="teleService.currentCall.fullScreen?'py-3': 'py-1'">
        <span class="dot text-uppercase select-color">{{this.auth.getCurrentUser().first_name[0]}}</span>
      </div>
    }
    <!-- <p style="color: white;">{{localMedia | json}}</p> -->
    @if (localMedia) {
      <div class="col-12 text-center ready-to-join-btn"
        [ngClass]="teleService.currentCall.fullScreen?'py-5': 'py-1'">
        <button class="primary-btn" (click)="joinCall()"> {{'button.ready_to_join' | translate | async}}
        </button>
      </div>
    }
    <!-- <video id="videoPlayer" width="640" height="480" *ngIf="localMedia"></video> -->
    @if (enableRejoin) {
      <div class="col-12 text-center text-light text-show"
        [ngClass]="teleService.currentCall.fullScreen?'full_screen_rejoin': 'mini_screen_rejoin'">
        {{'field.label.call_diasconnected' | translate | async}}
      </div>
    }
    <!-- <p style="color: white;">{{timer | json}}</p> -->
    @if (enableRejoin) {
      <div class="col-12 text-center rejoin-tele-call">
        <!-- <button class="primary-btn" id="rejoin" disabled *ngIf="showTimer"> {{timer}} seconds time remaining</button> -->
        @if (!audioOnly) {
          <button class="primary-btn" id="rejoin" (click)="rejoin()"> {{'field.label.rejoin_video_call' | translate |
          async}}</button>
        }
        @if (audioOnly) {
          <button class="primary-btn" id="rejoin" (click)="rejoin()"> {{'field.label.rejoin_audio_call' | translate |
          async}}</button>
        }
      </div>
    }
    @if (enableRejoin && !teleService.currentCall.minimized && checkEmr(teleService.currentCall.action)) {
      <div
        class="pt-1 col-12 text-center end-tele-call">
        @if (teleService.currentCall.action.detail_datasource) {
          <button class="secondary-btn" (click)="endConsualatation()"
            > {{'button.end_consultation' | translate | async}}
          </button>
        }
        @if (!teleService.currentCall.action.detail_datasource) {
          <button class="secondary-btn"
            (click)="viewEmr(teleService.currentCall.action,teleService.currentCall.emrKey);teleService.closeCall();teleService.setMessage(false)"
            > {{'button.view_prescription' | translate | async}}
          </button>
        }
      </div>
    }
    <!-- <div class="col-12 py-5 text-center" *ngIf="showTextCss"
    [ngClass]="teleService.currentCall.fullScreen?'py-3': 'py-1'" id="connectingText">
    <div class="dot text-uppercase select-color">{{this.auth.getCurrentUser().first_name[0]}}</div>
    <div class="text-light py-1 text-capitalize text-show">{{teleService.currentCall.name}} is not here
    </div>
  </div> -->
  <!-- {{teleService.currentCall.emrKey | json}} -->
  <h4 id="connectingText" class="py-5 centered" style="color: white;position: absolute;"></h4>
  @if (!localMedia) {
    <div class="video-group">
      @if (!hidelocalVideo) {
        <div id="local-player" class="player"
          [ngClass]="teleService.currentCall.fullScreen?'video-full-screen':'video-middle-screen'"
          style="position:absolute;display: inline-block;float: right;z-index: 1;right: 30px;">
        </div>
      }
      <div id="local_video_info" class="video-profile hide"></div>
      <div id="video_autoplay_local" class="autoplay-fallback hide"></div>
    </div>
  }
  <div id="remote-playerlist"></div>
</div>
}
</div>

@if (!teleService.currentCall.minimized) {
  <div class="kx-buttonSection align-items-center tele-footer-container" align="center"
    [ngStyle]="teleService.currentCall.fullScreen?{'background-color': '#fdfafa'}:{'background-color': ''}"
    ngxModalDraggable>
    @if (!showMenus) {
      <div class="tele-action-bar">
        @if (!teleService.currentCall.minimized && checkEmr(teleService.currentCall.action)) {
          <div class="tele-action"
            [ngStyle]="!teleService.currentCall.minimized && !teleService.currentCall.fullScreen?{'font-size':'13px'}:''"
            [ngClass]="checkNotification(teleService.currentCall.action)?'tele-action_font':''"
            (click)="getOrderDetails();teleService.changeToMiniPlayer();showHide()">
            <div>{{teleService.currentCall.action.prescription.view_emr_label | translate | async}}</div>
          </div>
        }
        @if (!teleService.currentCall.minimized && checkNotification(teleService.currentCall.action) && joinRoom) {
          <div class="tele-action"
            [ngStyle]="!teleService.currentCall.minimized && !teleService.currentCall.fullScreen?{'font-size':'13px'}:''"
            [ngClass]="checkNotification(teleService.currentCall.action)?'tele-action_font':''"
            (click)="sendNotification(teleService.currentCall.action.send_notification);showHide()">
            <div>{{teleService.currentCall.action.send_notification.label | translate | async}}</div>
          </div>
        }
        <div class="tele-action"
          [ngStyle]="!teleService.currentCall.minimized && !teleService.currentCall.fullScreen?{'font-size':'13px'}:''"
          [ngClass]="checkNotification(teleService.currentCall.action)?'tele-action_font':''"
          (click)="hideCamera();showHide()">
          @if (!showLocalVideo) {
            <div>{{'button.show_camera' | translate | async}}</div>
          }
          @if (showLocalVideo) {
            <div>{{'button.hide_camera' | translate | async}}</div>
          }
        </div>
      </div>
    }
    <div class="tele-footer-left pl-2 cursor-pointer">
      @if (teleService.currentCall.fullScreen) {
        <div
          class="d-flex justify-content-start align-items-center tele-status-icons" id="networkSpeed">
        </div>
      }
      @if (teleService.currentCall.fullScreen) {
        <div
          class="d-flex justify-content-start align-items-center tele-status-icons" id="duration">
        </div>
      }
      @if (teleService.currentCall.fullScreen) {
        <div
          class="d-flex justify-content-start align-items-center tele-status-icons" id="networkQuality">
        </div>
      }
    </div>
    @if (!localButton) {
      <div ngxModalDraggable>
        <!-- <img src="assets/images/telemedicine/ViewEmr.svg" class="mr-2" alt="Press to View EMR"
        *ngIf="teleService.currentCall.fullScreen && checkEmr(teleService.currentCall.action) && isMobile()"
        (click)="getOrderDetails();teleService.changeToMiniPlayer()"> -->
        <!-- <button (click)="switchCamera()">click me</button> -->
        @if (isMobile()) {
          <img src="assets/images/telemedicine/switch-Camera.svg" class="cursor-pointer"
            [ngClass]="teleService.currentCall.fullScreen?'pr-3':'pr-1'" alt="Press to Switch Camera"
            (click)="switchCamera()">
        }
        @if (!muteCss) {
          <img src="assets/images/telemedicine/unmute.png" class="cursor-pointer"
            [ngClass]="teleService.currentCall.fullScreen?'pr-3':'pr-1'" alt="Press to mute the audio"
            (click)="teleService.currentInstance.muteAudio();changeAgoraMuteStatus()">
        }
        @if (muteCss) {
          <img src="assets/images/telemedicine/mute.png" class="cursor-pointer" alt="Press to unmute the audio"
            [ngClass]="teleService.currentCall.fullScreen?'pr-3':'pr-1'"
            (click)="teleService.currentInstance.unMuteAudio();changeAgoraMuteStatus()">
        }
        <img src="assets/images/telemedicine/endCall.png" class="cursor-pointer" id="endCall" alt="Press to End Call"
          (click)="leavechannel(key,false)" [ngClass]="teleService.currentCall.fullScreen?'pr-3':'pr-1'">
        @if (!unmuteVideo) {
          <img src="assets/images/telemedicine/unmuteCamera.png" class="cursor-pointer" alt="press to off camera"
            (click)="teleService.currentInstance.mutecamera();changeCameraStatus()"
            [ngClass]="teleService.currentCall.fullScreen?'pr-3':'pr-1'">
        }
        @if (unmuteVideo) {
          <img src="assets/images/telemedicine/muteCamera.png" class="cursor-pointer" alt="Press to on Camera"
            (click)="teleService.currentInstance.unMuteCamera();changeCameraStatus()"
            [ngClass]="teleService.currentCall.fullScreen?'pr-3':'pr-1'">
        }
      </div>
    }
    @if (localButton) {
      <div ngxModalDraggable>
        <!-- <img src="assets/images/telemedicine/ViewEmr.svg" alt="Press to View EMR" class="mr-2"
        *ngIf="teleService.currentCall.fullScreen && checkEmr(teleService.currentCall.action) && isMobile()"
        (click)="getOrderDetails();teleService.changeToMiniPlayer()"> -->
        @if (!muteCss) {
          <img src="assets/images/telemedicine/unmute.png" class="cursor-pointer"
            [ngClass]="teleService.currentCall.fullScreen?'pr-3':'pr-1'" alt="Press to mute the audio"
            (click)="changeMuteStatus()">
        }
        @if (muteCss) {
          <img src="assets/images/telemedicine/mute.png" class="cursor-pointer" alt="Press to unmute the audio"
            [ngClass]="teleService.currentCall.fullScreen?'pr-3':'pr-1'" (click)="changeMuteStatus()">
        }
        @if (!unmuteVideo) {
          <img src="assets/images/telemedicine/unmuteCamera.png" class="cursor-pointer" alt="press to off camera"
            (click)="changeCameraStatus()" [ngClass]="teleService.currentCall.fullScreen?'pr-3':'pr-1'">
        }
        @if (unmuteVideo) {
          <img src="assets/images/telemedicine/muteCamera.png" class="cursor-pointer" alt="Press to on Camera"
            (click)="changeCameraStatus()" [ngClass]="teleService.currentCall.fullScreen?'pr-3':'pr-1'">
        }
      </div>
    }
    <div class="tele-additional-actions pr-2 tele-footer-right cursor-pointer">
      <div class="d-flex">
        @if (teleService.currentCall.fullScreen && checkEmr(teleService.currentCall.action)) {
          <figure class="prescription_option mr-2"
            (click)="getOrderDetails();teleService.changeToMiniPlayer()">
            <img src="assets/images/telemedicine/ViewEmr.svg" alt="Press to View EMR">
            <figcaption>{{teleService.currentCall.action.prescription.view_emr_label | translate | async}}</figcaption>
          </figure>
        }
        @if (teleService.currentCall.fullScreen && checkNotification(teleService.currentCall.action) && joinRoom) {
          <figure class="prescription_option m-0"
            (click)="sendNotification(teleService.currentCall.action.send_notification);">
            <i class="fa fa-bell notification-font-size" aria-hidden="true"></i>
            <figcaption>{{teleService.currentCall.action.send_notification.label | translate | async}}</figcaption>
          </figure>
        }
        @if (!showMenus && teleService.currentCall.fullScreen) {
          <div
            [ngClass]="teleService.currentCall.fullScreen?'_popupMenu': '_popupMenu minimize'" [ngStyle]="checkConsulat()">
            @if (showLocalVideo) {
              <p class="showUndeline" (click)="hideCamera();showHide()">{{'button.hide_camera' |
                translate | async}}
              </p>
            }
            @if (!showLocalVideo) {
              <p class="showUndeline" (click)="hideCamera();showHide()">{{'button.show_camera' |
                translate | async}}
              </p>
            }
            @if (teleService.currentCall.fullScreen && checkEmr(teleService.currentCall.action)) {
              <p class="prescription_option_mobile"
                (click)="getOrderDetails();teleService.changeToMiniPlayer()">
              {{teleService.currentCall.action.prescription.view_emr_label | translate | async}}</p>
            }
          </div>
        }
        @if (!hidethreeDots) {
          <span class="tele-three-dots" (click)="showHide()">
            <img src="assets/images/telemedicine/threeDots.svg" alt="click to open menu">
          </span>
        }
      </div>
    </div>
    @if (!teleService.currentCall.fullScreen) {
      <div align="center" class="align-items-center tele-status-icons"
        id="duration">
      </div>
    }
  </div>
}

<div dhs-modal></div>
<!--Comment for new telemedicine design-->

<!-- Added html by himanshu verma-->

<!--html for joining video call-->
<!--<div class="_wf-tm-mainbody">
<div class="_wf-tm-line-tob _wf-tm-line-tob-2"> </div>
<div class="maindivv wp-bg-black">
  <div class="_wf-tm-topddiv">
    <div class="_wf-tm-text-top _wf-tm-text-top-2">
      <div class="_wf-tm-name-2 _wf-tm-name-2-1">
        <div class="_wf-tm-txtblock9 _wf-tm-txtblock9-1">Mr. Manvendra</div>
      </div>
      <div class="_wf-tm-lft-icons _wf-tm-lft-icons-3">
        <div class="_wf-tm-border wp-border2 _wf-tm-border-3">
          <div class="_wf-tm-txtblock7 _wf-tm-txtblock7-3"><i class="fa fa-square"></i></div>
        </div>
        <div class="_wf-tm-border wp-border2 wp-border3 _wf-tm-border-3">
          <div class="_wf-tm-txtblock8 _wf-tm-txtblock8-3"><i class="fa fa-square"></i></div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="_wf-tm-lmain">
  <div class="_wf-tm-white-bg">
    <div class="_wf-tm-txt-con">
      <div>Welcome Dr. Lakshmi Menon,<br><span>Mr. Manvendra is waiting for you</span></div>
    </div>
    <div class="_wf-tm-lm-circle">
      <div class="_wf-tm-block-div">
        <div class="_wf-tm-bg-blue _wf-tm-bg-blue-2">
          <div class="_wf-tm-blc3">
            <div class="_wf-tm-txtblk-lm">LM</div>
          </div>
        </div>
      </div>
      <div class="_wf-tm-joindiv">
        <div class="_wf-tm-block-div">
          <div class="_wf-tm-bg-white">
            <div class="_wf-tm-dictxt">
              <div>Ready to join</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="_wf-tm-tm-btn-btm _wf-tm-tm-btn-btm-1">
  <div class="_wf-tm-lft-colicons _wf-tm-lft-colicons-2">
    <div class="_wf-tm-icons-btm _wf-tm-icons-btm-2">
      <div class="_wf-tm-wifi _wf-tm-wifi-2">
        <div class="_wf-tm-bivblk-69 _wf-tm-bivblk-69-2"><i class="fa fa-wifi"></i></div>
      </div>
      <div class="_wf-tm-wifi _wf-tm-wifi-2">
        <div class="_wf-tm-bivblk-69"><i class="fa fa-clock-o"></i></div>
      </div>
      <div class="_wf-tm-wifi _wf-tm-wifi-2">
        <div class="_wf-tm-bivblk-69"><i class="fa fa-signal"></i></div>
      </div>
    </div>
    <div class="_wf-tm-icons-btm wp-txt-btm _wf-tm-icons-btm-2">
      <div class="_wf-tm-wifi wp-txt-1 _wf-tm-wifi-3">
        <div class="_wf-tm-bivblk-69">900.23kbps</div>
      </div>
      <div class="_wf-tm-wifi _wf-tm-wifi-3">
        <div class="_wf-tm-bivblk-69 wp-txt2">12min 19sec</div>
      </div>
      <div class="_wf-tm-wifi wp-txt3 _wf-tm-wifi-3">
        <div class="_wf-tm-bivblk-69">Good</div>
      </div>
    </div>
  </div>
  <div class="_wf-tm-btn-bg-black">
    <div class="_wf-tm-divblock1">
      <div class="_wf-tm-divblck2 _wf-pp-blue"><img src="assets/images/vid-call-icon-mic.svg" loading="lazy" alt=""></div>
      <div class="_wf-tm-divblck2 _wf-pp-white"><img src="assets/images/vid-call-icon-mic-red.svg" loading="lazy" alt=""></div>
    </div>
    <div class="_wf-tm-divblock1">
      <div class="_wf-tm-divblck2 _wf-pp-white"><img src="assets/images/vid-call-icon-vid-red.svg" loading="lazy" alt=""></div>
      <div class="_wf-tm-divblck2 _wf-pp-blue"><img src="assets/images/vid-call-icon-vid.svg" loading="lazy" alt=""></div>
    </div>
    <div class="_wf-tm-divblock1">
      <div class="_wf-tm-divblck2 _wf-pp-blue"><img src="assets/images/vid-call-icon-disconnect.svg" loading="lazy" alt=""></div>
    </div>
  </div>
  <div class="_wf-tm-emr-txt _wf-tm-emr-txt-1">
    <div class="_wf-tm-emr-icon _wf-tm-emr-icon-1"><img src="https://uploads-ssl.webflow.com/5fad0c21e1c24ef5fe4aaf0b/5fbcd8ec1a2f0f1911ff83d1_emr-icon.png" loading="lazy" alt="">
      <div class="_wf-tm-txt-pres _wf-tm-txt-pres-1">
        <div class="_wf-tm-txtblk-sendpre">Send prescription/View EMR</div>
      </div>
    </div>
  </div>
</div>-->
<!--html for running cal;-->
<!--

<div class="_wf-tm-doctor-img"><img src="assets/images/doctor-bg.png" loading="lazy" width="405" alt="" class="imagecenter">
  <div class="_wf-tm-img-pat"><img src="assets/images/patient-squ.png" loading="lazy" width="181" alt="" class="image-5"></div>
</div>-->
<!--html for cutting the phone-->
<!--

<div class="_wf-tm-main-bg blockaftercancelthecall">
  <div class="_wf-tm-white-bg">
    <div class="_wf-tm-txt-con">
      <div class="_wf-tm-lftconsullt">&lt;You left the consultation&gt;</div>
    </div>
    <div class="_wf-tm-block-div">
      <div class="_wf-tm-bg-blue">
        <div class="_wf-tm-blc3">
          <div class="_wf-tm-txtrejoin">Rejoin video consultation</div>
        </div>
      </div>
      <div class="_wf-tm-bg-white">
        <div class="_wf-tm-dictxt">
          <div class="_wf-tm-txtconsult">End Consultation</div>
        </div>
      </div>
    </div>
    <div class="_wf-tm-last-txt">
      <div class="_wf-tm-txtback">#This will go back to the order screen</div>
    </div>
  </div>
  <div class="_wf-tm-bg-main">
    <div class="_wf-tm-blk-white">
      <div class="_wf-tm-con-txt">
        <div class="_wf-tm-txtblk-lft">You left the consultation</div>
      </div>
      <div class="_wf-tm-blue-bg">
        <div class="_wf-tm-divblk-rejoin">
          <div class="_wf-tm-txtblk-video">Rejoin video consultation</div>
        </div>
      </div>
      <div class="_wf-tm-white-blk">
        <div class="_wf-tm-divblk-bck">
          <div class="_wf-tm-txtblk-bak">Back to homepage</div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
-->